import { render, staticRenderFns } from "./KundeBoardMessages.vue?vue&type=template&id=42fdba37&"
import script from "./KundeBoardMessages.vue?vue&type=script&lang=js&"
export * from "./KundeBoardMessages.vue?vue&type=script&lang=js&"
import style0 from "./KundeBoardMessages.vue?vue&type=style&index=0&id=42fdba37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports